/**
 * @generated SignedSource<<022f30a783b52f69172de680f6faf9be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CustomDomainStatus = "ACTIVE" | "DNS_RECORD_MISSING" | "NOT_PAID" | "%future added value";
export type OnboardingType = "CLIENT" | "CONTRACTOR" | "%future added value";
export type TopIndependentStatus = "DISCOVERED" | "OPTED_IN" | "OPTED_OUT" | "UNDISCOVERED" | "%future added value";
export type UserFeature = "ADD_NOTE_TO_CONTACT_OWN" | "ADD_NOTE_TO_CONTACT_OWN_ORGANIZATION" | "APPLY_TO_JOB" | "APPLY_TO_JOB_POSTING" | "ARCHIVE_JOB_POSTING_ALL" | "ARCHIVE_JOB_POSTING_OWN" | "ARCHIVE_JOB_POSTING_OWNR_TEAM" | "ARCHIVE_JOB_POSTING_OWN_ORGANIZATION" | "AUTOMATICALLY_APPROVE_PAID_PROJECT_INVITE" | "AUTOMATICALLY_MATCH_WITH_CREATED_JOB_POSTINGS" | "AUTOMATICALLY_RATE_PROFILE" | "BLOCK_USERS" | "C4C_REFERRAL_PROGRAM" | "CAN_SYNC_WITH_HUBSPOT" | "CHANGE_ORGANIZATION_MEMBER_ROLE_OWN_ORGANIZATION" | "CHAT_ENABLED" | "CHECK_FOR_INAPPROPRIATE_CONTENT" | "CLAIM_ORGANIZATION" | "CLIENT_REFERRAL_PILOT" | "COMMUNITY_FEED_CANNOT_POST" | "COMMUNITY_FEED_CAN_BOOST_SOCIAL_POST" | "COMMUNITY_FEED_CAN_CURATE" | "COMMUNITY_FEED_CAN_DELETE_SOCIAL_POST" | "COMMUNITY_FEED_CAN_FEATURE_SOCIAL_POST" | "COMMUNITY_FEED_CAN_MANAGE_ADMIN_TAGS" | "COMMUNITY_FEED_CAN_POST" | "COMMUNITY_FEED_CAN_VIEW_FEED" | "CONTRA_PRO_SUBSCRIBER" | "CREATE_COMMUNITY_JOB_POSTINGS" | "CREATE_CURATED_PROJECT_LISTS" | "CREATE_JOB_OWN" | "CREATE_JOB_OWN_ORGANIZATION" | "CREATE_JOB_OWN_TEAM" | "CREATE_JOB_POSTING" | "CREATE_JOB_POSTING_OWN" | "CREATE_JOB_POSTING_OWN_ORGANIZATION" | "CREATE_JOB_POSTING_OWN_TEAM" | "CREATE_MANUAL_TEST_USER" | "CREATE_PAID_PROJECT_INQUIRY" | "CREATE_PAID_PROJECT_INVITE" | "DELETE_SOCIAL_POST" | "DELETE_USERS" | "EDIT_CONTACT_OWN" | "EDIT_CONTACT_OWN_ORGANIZATION" | "EDIT_JOB_ALL" | "EDIT_JOB_OWN" | "EDIT_JOB_OWN_ORGANIZATION" | "EDIT_JOB_OWN_TEAM" | "EDIT_JOB_POSTING_DETAILS_ALL" | "EDIT_JOB_POSTING_DETAILS_OWN" | "EDIT_JOB_POSTING_DETAILS_OWN_ORGANIZATION" | "EDIT_JOB_POSTING_DETAILS_OWN_TEAM" | "EDIT_ORGANIZATION_DETAILS_ALL" | "EDIT_ORGANIZATION_DETAILS_OWN_ORGANIZATION" | "ENABLE_CONTRA_FOR_COMPANIES_FOR_ORGANIZATION" | "FAST_FORWARD_CADENCE_CYCLE" | "FEATURE_SOCIAL_POST" | "FRAMER_AD_EXPERIMENT_SHOW_ANALYTICS_TAB_AD" | "FRAMER_AD_EXPERIMENT_SHOW_EXPERT_PAGE_AD" | "FRAMER_AD_EXPERIMENT_SHOW_INDEPENDENT_HOME_AD" | "FRAMER_AD_EXPERIMENT_SHOW_JOBS_PAGE_AD" | "FRAMER_AD_EXPERIMENT_SHOW_PROJECT_CREATION_AD" | "FRAMER_AD_EXPERIMENT_SHOW_SERVICES_CREATION_AD" | "FRAMER_AD_EXPERIMENT_SHOW_SIDE_NAV_AD" | "GENERATE_INTERNAL_SLACK_NOTIFICATIONS" | "HIDE_CONTRACTOR_COMPLETE_PROFILE_CHECKLIST" | "HIDE_FROM_ANALYTICS" | "HIDE_FROM_SEARCH_ENGINES" | "HIDE_FROM_USER_SEARCH" | "HIDE_FROM_USER_SUGGESTIONS" | "IMPERSONATE_USERS" | "IMPORT_PORTFOLIO_PROJECT" | "INDEXABLE_BY_SEARCH_ENGINES" | "INDEXABLE_FOR_USER_SEARCH" | "INSTANT_ACCESS_TO_JOB_POSTINGS" | "INVITE_ORGANIZATION_MEMBER_ROLE_ADMIN_OWN_ORGANIZATION" | "INVITE_ORGANIZATION_MEMBER_ROLE_MEMBER_OWN_ORGANIZATION" | "LIST_ORGANIZATION_MEMBERS_OWN_ORGANIZATION" | "MANAGE_ACH_PAYMENT_REQUESTS" | "MANAGE_BASIC_OPPORTUNITIES" | "MANAGE_DIRECT_PAYMENTS" | "MANAGE_EXCLUSIVE_OPPORTUNITIES" | "MANAGE_HIRING_CREDITS" | "MANAGE_INDEPENDENT_PORTFOLIO_TEMPLATES" | "MANAGE_JOB_BOOST_REQUESTS" | "MANAGE_JOB_POSTINGS" | "MANAGE_JOB_POSTING_APPLICANTS_ALL" | "MANAGE_JOB_POSTING_APPLICANTS_OWN" | "MANAGE_JOB_POSTING_APPLICANTS_OWN_ORGANIZATION" | "MANAGE_JOB_POSTING_APPLICANTS_OWN_TEAM" | "MANAGE_LEDGER_TRANSACTIONS" | "MANAGE_LISTS" | "MANAGE_NOTIFICATIONS" | "MANAGE_ORGANIZATIONS" | "MANAGE_ORGANIZATION_CLAIM_REQUESTS" | "MANAGE_ORGANIZATION_JOIN_REQUEST_FOR_ALL" | "MANAGE_PAID_PROJECTS_ALL" | "MANAGE_PAID_PROJECTS_OWN" | "MANAGE_PAID_PROJECTS_OWN_ORGANIZATION" | "MANAGE_PAID_PROJECTS_OWN_TEAM" | "MANAGE_PAID_PROJECT_INQUIRIES" | "MANAGE_PAYMENT_METHODS_OWN" | "MANAGE_PAYMENT_METHODS_OWN_ORGANIZATION" | "MANAGE_PROFESSIONAL_ROLES" | "MANAGE_PROFESSIONAL_TOOLS" | "MANAGE_THEME_CUSTOMIZATION" | "MANAGE_USER_GROUPS" | "MANAGE_USER_INTERFACE_FLAGS" | "MANAGE_USER_WAITLISTS" | "MANAGE_WORKSPACE_GROUPS" | "MANUAL_LEDGER_ENTRY" | "PROFILE_INTRODUCTION_VIDEO" | "PUBLISH_INDEPENDENT_PORTFOLIO" | "RATE_USERS" | "RECEIVE_EMAILS" | "RECEIVE_INDY_ONBOARDING_WELCOME_EMAILS" | "RECEIVE_PAID_PROJECT_INQUIRY" | "REFERRAL_PROGRAM_MEMBER" | "RELUME_ADS_SHOW_ANALYTICS_TAB_AD" | "RELUME_ADS_SHOW_EXPERT_PAGE_AD" | "RELUME_ADS_SHOW_INDEPENDENT_HOME_AD" | "RELUME_ADS_SHOW_JOBS_PAGE_AD" | "RELUME_ADS_SHOW_PROJECT_CREATION_AD" | "RELUME_ADS_SHOW_SERVICES_CREATION_AD" | "RELUME_ADS_SHOW_SIDE_NAV_AD" | "REQUEST_JOB_POSTING_IMPORT" | "REQUEST_MORE_MATCHES_FOR_JOB_POSTING_OWN" | "REQUEST_MORE_MATCHES_FOR_JOB_POSTING_OWN_ORGANIZATION" | "REQUEST_MORE_MATCHES_FOR_JOB_POSTING_OWN_TEAM" | "REQUIRE_CONTRACT_SIGNATURE" | "RESOLVE_PAID_PROJECT_DISPUTES" | "RESTORE_LEDGER_BALANCE_FOR_FAILED_PAYOUTS" | "SEARCH_COMMUNITY_JOBS" | "SEARCH_TEST_USERS" | "SEARCH_USERS" | "SEND_ARBITRARY_GRAPHQL_REQUESTS" | "SERVICE_INTRODUCTION_VIDEO" | "SET_PROFILE_APPROVAL_STATUS" | "SET_USER_ONBOARDING_TYPE" | "SHARED_NETWORK" | "SHOW_DISCOVER_PROFILE_PREVIEW_CARD" | "SHOW_IN_USER_SEARCH" | "SKIP_AUTOMATED_JOB_POSTING_MATCHING" | "SKIP_AUTO_RATING" | "SKIP_INAPPROPRIATE_CONTENT_CHECK" | "SKIP_SENDING_CHAT_MESSAGES" | "SKIP_SENDING_EMAILS" | "SKIP_SENDING_INTERNAL_SLACK_NOTIFICATIONS" | "SKIP_SIGNING_CONTRACT" | "SOCIAL_REFERRAL_PROGRAM" | "SUBSCRIBE_TO_PORTFOLIOS" | "SYNC_WITH_ANALYTICS" | "USER_DATA_INCLUDED_IN_SUGGESTIONS" | "USE_CLIENT_SHORTCUTS_MENU" | "USE_CONTRACTOR_SHORTCUTS_MENU" | "USE_CRYPTO_SANDBOX" | "USE_EVERSIGN_SANDBOX" | "USE_LEDGER_SANDBOX" | "USE_PAYONEER_SANDBOX" | "USE_PAYPAL_SANDBOX" | "USE_PERSONA_SANDBOX" | "USE_STRIPE_SANDBOX" | "VIEW_INVOICE_ALL" | "VIEW_INVOICE_OWN" | "VIEW_INVOICE_OWN_ORGANIZATION" | "VIEW_INVOICE_OWN_TEAM" | "VIEW_IN_DEVELOPMENT_PORTFOLIO_TEMPLATES" | "VIEW_JOBS_ALL" | "VIEW_JOBS_OWN" | "VIEW_JOBS_OWN_ORGANIZATION" | "VIEW_JOBS_OWN_TEAM" | "VIEW_JOB_FEED" | "VIEW_JOB_POSTINGS_ALL" | "VIEW_JOB_POSTINGS_OWN_ORGANIZATION" | "VIEW_JOB_POSTINGS_OWN_TEAM" | "VIEW_JOB_POSTING_OWN" | "VIEW_PAID_PROJECTS_ALL" | "VIEW_PAID_PROJECTS_OWN" | "VIEW_PAID_PROJECTS_OWN_ORGANIZATION" | "VIEW_PAID_PROJECTS_OWN_TEAM" | "VISUAL_ELECTRIC_ADS_SHOW_ANALYTICS_TAB_AD" | "VISUAL_ELECTRIC_ADS_SHOW_EXPERT_PAGE_AD" | "VISUAL_ELECTRIC_ADS_SHOW_INDEPENDENT_HOME_AD" | "VISUAL_ELECTRIC_ADS_SHOW_JOBS_PAGE_AD" | "VISUAL_ELECTRIC_ADS_SHOW_PROJECT_CREATION_AD" | "VISUAL_ELECTRIC_ADS_SHOW_SERVICES_CREATION_AD" | "VISUAL_ELECTRIC_ADS_SHOW_SIDE_NAV_AD" | "WIX_STUDIO_ADS_SHOW_ANALYTICS_TAB_AD" | "WIX_STUDIO_ADS_SHOW_EXPERT_PAGE_AD" | "WIX_STUDIO_ADS_SHOW_INDEPENDENT_HOME_AD" | "WIX_STUDIO_ADS_SHOW_JOBS_PAGE_AD" | "WIX_STUDIO_ADS_SHOW_PROJECT_CREATION_AD" | "WIX_STUDIO_ADS_SHOW_SERVICES_CREATION_AD" | "WIX_STUDIO_ADS_SHOW_SIDE_NAV_AD" | "%future added value";
export type UserGroup = "ADMIN" | "BLOCKED_USER" | "BOTSTACKS_EXPERT" | "BUBBLE_EXPERT" | "BUILDSHIP_EXPERT" | "C4C_REFERRAL_PROGRAM" | "CLIENT_ONBOARDING_COMPLETE" | "CLIENT_REFERRAL_PILOT" | "COMMUNITY_FEED_BANNED_FROM_POSTING" | "COMMUNITY_FEED_CREATOR" | "COMMUNITY_FEED_CURATOR" | "COMMUNITY_FEED_MEMBER" | "COMMUNITY_FEED_VIEWER" | "COMMUNITY_MANAGER" | "CONTRACTOR_ONBOARDING_COMPLETE" | "CONTRACTOR_PROFILE_COMPLETE" | "CONTRA_EXPERT_TEST" | "CONTRA_FOR_COMPANIES_CLIENT" | "CONTRA_PRO_ACCESS_CODE_EVENT" | "CONTRA_PRO_OLD_PRICE_GROUP" | "CONTRA_TEAM_MEMBER" | "CREATOR_PORTFOLIO_EARLY_ACCESS" | "DESCRIPT_EXPERT" | "EXCLUDED_FROM_DISCOVER" | "EXCLUDED_FROM_MATCHING" | "FLAGGED_USER" | "FLAG_FOR_IMPROVEMENT" | "FLUTTERFLOW_EXPERT" | "FRAMER_AD_EXPERIMENT_ANALYTICS_TAB_AUDIENCE" | "FRAMER_AD_EXPERIMENT_EXPERT_PAGE_AUDIENCE" | "FRAMER_AD_EXPERIMENT_INDEPENDENT_HOME_AUDIENCE" | "FRAMER_AD_EXPERIMENT_JOBS_PAGE_AUDIENCE" | "FRAMER_AD_EXPERIMENT_PROJECT_CREATION_AUDIENCE" | "FRAMER_AD_EXPERIMENT_SERVICES_CREATION_AUDIENCE" | "FRAMER_AD_EXPERIMENT_SIDE_NAV_AUDIENCE" | "FRAMER_EXPERT" | "GLORIFY_EXPERT" | "HAS_CUSTOM_EMAIL_DOMAIN" | "HEY_GEN_EXPERT" | "HEY_GEN_VIDEO_EDITOR_EXPERT" | "INSTANT_EXPERT" | "INTEGRATION_TEST_USER" | "JITTER_EXPERT" | "JOB_NETWORK_ACCESS_APPROVED" | "KITTL_EXPERT" | "LOTTIEFILES_X_FIGMA_EXPERT" | "LOTTIEFILES_X_FRAMER_EXPERT" | "LOTTIEFILES_X_WEBFLOW_EXPERT" | "LOW_RATED_USER" | "LUMMI_EXPERT" | "MANUAL_DEMO_USER" | "MANUAL_TEST_USER" | "ORGANIZATION_MEMBER" | "ORGANIZATION_MEMBER_ROLE_ADMIN" | "ORGANIZATION_MEMBER_ROLE_CONTRA_ADMIN" | "PEACHWEB_EXPERT" | "PORTFOLIO_DEVELOPER" | "PORTFOLIO_EARLY_ADOPTER" | "QUICK_RESPONDER" | "READYMAG_EXPERT" | "RELUME_ADS_ANALYTICS_TAB_AUDIENCE" | "RELUME_ADS_EXPERT_PAGE_AUDIENCE" | "RELUME_ADS_INDEPENDENT_HOME_AUDIENCE" | "RELUME_ADS_JOBS_PAGE_AUDIENCE" | "RELUME_ADS_PROJECT_CREATION_AUDIENCE" | "RELUME_ADS_SERVICES_CREATION_AUDIENCE" | "RELUME_ADS_SIDE_NAV_AUDIENCE" | "RELUME_EXPERT" | "REPLO_EXPERT" | "RIVE_EXPERT" | "SOCIAL_FEATURE_ELIGIBLE" | "SPLINE_EXPERT" | "STANDARD_CLIENT" | "TEST_ADMIN" | "TOP_INDEPENDENT_DISCOVERED" | "TOP_INDEPENDENT_OPTED_IN" | "TOP_INDEPENDENT_OPTED_OUT" | "USER_WITH_INQUIRY_AUTO_APPROVAL" | "USER_WITH_INVOICE_AUTO_APPROVAL" | "USER_WITH_JOB_POSTING_AUTO_APPROVAL" | "USER_WITH_PAID_PROJECT_INVITE_AUTO_APPROVAL" | "VISUAL_ELECTRIC_ADS_ANALYTICS_TAB_AUDIENCE" | "VISUAL_ELECTRIC_ADS_EXPERT_PAGE_AUDIENCE" | "VISUAL_ELECTRIC_ADS_INDEPENDENT_HOME_AUDIENCE" | "VISUAL_ELECTRIC_ADS_JOBS_PAGE_AUDIENCE" | "VISUAL_ELECTRIC_ADS_PROJECT_CREATION_AUDIENCE" | "VISUAL_ELECTRIC_ADS_SERVICES_CREATION_AUDIENCE" | "VISUAL_ELECTRIC_ADS_SIDE_NAV_AUDIENCE" | "WEBFLOW_EXPERT" | "WEBSTUDIO_EXPERT" | "WIX_STUDIO_ADS_ANALYTICS_TAB_AUDIENCE" | "WIX_STUDIO_ADS_EXPERT_PAGE_AUDIENCE" | "WIX_STUDIO_ADS_INDEPENDENT_HOME_AUDIENCE" | "WIX_STUDIO_ADS_JOBS_PAGE_AUDIENCE" | "WIX_STUDIO_ADS_PROJECT_CREATION_AUDIENCE" | "WIX_STUDIO_ADS_SERVICES_CREATION_AUDIENCE" | "WIX_STUDIO_ADS_SIDE_NAV_AUDIENCE" | "WIX_STUDIO_EXPERT" | "WORKSPACE_ADDED_CONTACT" | "%future added value";
export type WaitListNid = "C4C" | "COMMUNITY_FEED" | "EXPERT_NETWORKS" | "FINANCE_INTEGRATION" | "GROWTH_RECOMMENDATIONS" | "HOURLY_ONGOING_PROJECTS" | "INDEPENDENT_PORTFOLIOS_ALPHA" | "OTHER" | "PRO_ANALYTICS" | "RATE_CALCULATOR" | "SLACK_CLIENT_INTEGRATION" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CurrentUserContext_userAccount$data = {
  readonly analyticsUserId: string;
  readonly customDomains: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly domain: string;
        readonly status: CustomDomainStatus;
      };
    }>;
  };
  readonly emailAddress: string | null;
  readonly id: string;
  readonly isTestAccount: boolean;
  readonly onboardingType: OnboardingType;
  readonly profile: {
    readonly avatarImage: {
      readonly uid: string;
    } | null;
    readonly displayUsername: string;
    readonly firstName: string | null;
    readonly generalInquiryCtaIsVisible: boolean;
    readonly hasActivePortfolioSubscription: boolean;
    readonly id: string;
    readonly independentPortfolioTemplateTheme: {
      readonly id: string;
      readonly template: {
        readonly displayName: string;
        readonly id: string;
      };
    } | null;
    readonly isFramerExpert: boolean;
    readonly lastName: string | null;
    readonly primaryProfessionalCategory: string | null;
    readonly receivedTestimonials: {
      readonly count: number;
    };
    readonly title: string | null;
    readonly topIndependentStatus: TopIndependentStatus;
    readonly workPreferences: {
      readonly isCurrentlyAvailable: boolean;
    };
  };
  readonly userFeatures: ReadonlyArray<UserFeature>;
  readonly userGroups: ReadonlyArray<UserGroup>;
  readonly waitLists: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly nid: WaitListNid;
      };
    }>;
  };
  readonly " $fragmentType": "CurrentUserContext_userAccount";
};
export type CurrentUserContext_userAccount$key = {
  readonly " $data"?: CurrentUserContext_userAccount$data;
  readonly " $fragmentSpreads": FragmentRefs<"CurrentUserContext_userAccount">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CurrentUserContext_userAccount",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "analyticsUserId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "onboardingType",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTestAccount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CustomDomainConnection",
      "kind": "LinkedField",
      "name": "customDomains",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomDomainEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomDomain",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "domain",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ContraImage",
          "kind": "LinkedField",
          "name": "avatarImage",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uid",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasActivePortfolioSubscription",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "topIndependentStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFramerExpert",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "generalInquiryCtaIsVisible",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IndependentPortfolioTemplateTheme",
          "kind": "LinkedField",
          "name": "independentPortfolioTemplateTheme",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "IndependentPortfolioTemplate",
              "kind": "LinkedField",
              "name": "template",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                },
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "WorkPreferences",
          "kind": "LinkedField",
          "name": "workPreferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isCurrentlyAvailable",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ReceivedTestimonialConnection",
          "kind": "LinkedField",
          "name": "receivedTestimonials",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primaryProfessionalCategory",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayUsername",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userGroups",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userFeatures",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WaitListConnection",
      "kind": "LinkedField",
      "name": "waitLists",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WaitListEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WaitList",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "nid",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserAccount",
  "abstractKey": null
};
})();

(node as any).hash = "f62911296f1e24bf514a9eead55182c5";

export default node;
